import {CiLocationOn} from 'react-icons/ci'
import {BsFillPeopleFill} from 'react-icons/bs'
import {AiOutlineMail} from 'react-icons/ai'
import {AiFillPhone} from 'react-icons/ai'

const data = [
    {id: 1, icon: <CiLocationOn/>, title: 'LOCATION', desc: '82 Akpaube Street (Unity house) off Aka-Etinan Road, & off IBB Way, Uyo, AKS.'},
    {id: 2, icon: <BsFillPeopleFill/>, title: 'OPEN', desc: 'Weekdays: 7:30am - 6:30pm & Weekends: 9:00am - 2:00pm'},
    {id: 3, icon: <AiOutlineMail/>, title: 'EMAIL', desc: 'admin@akmekmed.com; akmekmed82@gmail.com'},
    {id: 4, icon: <AiFillPhone/>, title: 'EMERGENCY', desc: '+234 813 666 8800; +234 803 582 3348'},
]

export default data;